<template>
  <div class="sold-membership-rank">
    <div
      v-for="soldMembership in soldMemberships"
      v-if="isRecordRange"
      :key="soldMembership.id"
      class="sold-membership-item"
    >
      <div class="sold-membership-rank__left">
        <div
          class="sold-membership-rank__graph"
          :style="presentGraphStyle(soldMembership)"
        />
        <div class="sold-membership-rank__title">
          {{ soldMembership.membershipName }}
        </div>
      </div>
      <div class="sold-membership-rank__count">
        {{ soldMembership.numOfSales }}건
      </div>
    </div>

    <div
      v-show="soldMemberships.length === 0 || !isRecordRange"
      class="empty-message"
      style="min-height: 400px;"
    >
      <warning-message :message="emptyMessage" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import dateFns from 'date-fns';
import WarningMessage from '../../components/element-ui/WarningMessage';

export default {
  name: 'SoldMembershipRank',
  components: { WarningMessage },
  props: {
    soldMemberships: {
      type: Array,
      default: [],
    },
    curDate: {
      default: new Date(),
    },
  },
  computed: {
    maxCount() {
      return _.maxBy(this.soldMemberships, 'numOfSales').numOfSales;
    },
    emptyMessage() {
      if (this.isRecordRange) {
        return '매출 내역이 없습니다.';
      } 
      return '집계 기간이 아닙니다.';
			
    },
    isRecordRange() {
      return dateFns.isWithinRange(
        this.curDate,
        new Date('2019-01-01'),
        new Date(),
      );
    },
  },
  methods: {
    presentGraphStyle(soldMembership) {
      return {
        width: `${(soldMembership.numOfSales / this.maxCount) * 100}%`,
      };
    },
  },
};
</script>

<style lang="scss">
.sold-membership-rank {
	padding: 25px;
	height: 450px;
	overflow-y: auto;
}

.sold-membership-item {
	display: flex;
	height: 30px;
	margin-bottom: 10px;
}

.sold-membership-rank__left {
	flex: auto;
	position: relative;

	.sold-membership-rank__title {
		line-height: 30px;
		position: absolute;
		top: 0;
		left: 12px;
		font-size: 13px;
	}
}

.sold-membership-rank__graph {
	background-color: #f2f2f2;
	height: 30px;
	border-radius: 9px;
	position: absolute;
	top: 0;
	left: 0;
}

.sold-membership-rank__count {
	width: 80px;
	flex: initial;
	line-height: 30px;

	font-size: 15px;
	font-weight: 500;
	letter-spacing: -0.6px;
	text-align: right;
	color: #4a4a4a;
}
</style>
